console.log(process.env, 'Env file');
export const SERVER_IP =
	process.env.REACT_APP_ENV === 'stage'
		? 'https://stageapi.fitte.in/'
		: process.env.REACT_APP_ENV === 'prod'
		? 'https://api.fitte.in/'
		: // : 'https://api.fitte.in/';
		  'http://localhost:5000/';

// export const SERVER_IP = 'https://stageapi.fitte.in/';
// export const SERVER_IP = 'https://api.fitte.in/';
// export const SERVER_IP = 'http://3.135.37.212/v1/';
// export const SERVER_IP = "http://auth.zopay.in/v1";
export const SHOW_API_NAME_IN_NOTIFICATION = true;
export const NOTIFICATION_DURATION = 5;
